import { ITranslationsCollection } from '@estee/elc-service';
import { action, observable } from 'mobx';
import {
    OrderApiResponseCode,
    OrderTrackingApiSdk,
    EncryptedOrderNumberDataType
} from '../../api/OrderTrackingApiSdk';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { IOrderTrackingConfig } from '../domain/entities/Config';
import { OrderInfo } from '../domain/entities/OrderInfo';
import { OrderTracking } from '../domain/entities/OrderTracking';
import { ConfigRepository } from './ConfigRepository';

interface IOrderTrackingData {
    responseCode: OrderApiResponseCode;
    orderInfo: OrderInfo;
}

export class OrderRepository {
    @observable public orderInfo?: OrderInfo;
    @observable public translations: ITranslationsCollection;
    @observable public orderTracking: OrderTracking;

    private orderTrackingApiSdk: OrderTrackingApiSdk;
    @observable private orderTrackingConfig: IOrderTrackingConfig;

    constructor(orderTrackingApiSdk: OrderTrackingApiSdk) {
        this.orderTrackingApiSdk = orderTrackingApiSdk;
        const configRepository: ConfigRepository = diContainer.get(serviceNames.configRepository);
        this.orderTrackingConfig = configRepository.orderTrackingConfig;
        this.orderTracking = new OrderTracking(
            this.orderTrackingConfig?.orderNumberValidationRegex
        );
    }

    @action
    public loadTranslations(translations: ITranslationsCollection) {
        this.translations = translations;
    }

    @action
    public async getOrderTrackingData(
        query: string | EncryptedOrderNumberDataType
    ): Promise<IOrderTrackingData> {
        this.orderInfo = undefined;
        const { data, code } = await this.orderTrackingApiSdk.getOrderTracking(query);
        if (data) {
            this.orderInfo = OrderInfo.fromJSON(data, this.orderTrackingConfig, this.translations);
        }

        return { responseCode: code, orderInfo: this.orderInfo as OrderInfo };
    }
}
